export function initWishlist() {
  BlsWishlistHeader.init?.();
  document.addEventListener('click', function (e) {
    const wishlistButton = e.target.closest('.bls__wishlist-button-js');
    if (wishlistButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    } else {
      return;
    }
  
    e.preventDefault();
    const productHandle = wishlistButton.dataset.productHandle;
  
    const wishlistItems = JSON.parse(localStorage.getItem('bls__wishlist-items')) || [];
    const index = wishlistItems.indexOf(productHandle);
  
    if (index === -1) {
      wishlistItems.push(productHandle);
      wishlistButton.classList.add('active');
    } else {
      wishlistItems.splice(index, 1);
      wishlistButton.classList.remove('active');
    }
  
    localStorage.setItem('bls__wishlist-items', JSON.stringify(wishlistItems));
  
    BlsSubActionProduct?.handleInitWishlist?.();
  }, true);
}